import { render } from "./AddFonction.vue?vue&type=template&id=2396e0f4&ts=true"
import script from "./AddFonction.vue?vue&type=script&lang=ts"
export * from "./AddFonction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__